import { makeStyles } from 'tss-react/mui';
import { keyframes } from 'tss-react';

export const useStyles = makeStyles()(() => {
  const pulse = keyframes`
  0% {
    transform: scale(0.95);
     box-shadow: 0 0 0 0 rgba(110, 3, 246, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 16px rgba(0, 0, 0, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }`;

  return {
    pulse: {
      animation: `${pulse} 2s infinite`,

      '&:hover': {
        animation: 'none',
      },
    },
  };
});
